import {useMainStore} from "@/store";

/**
 * Removes notifications for applications/invites that no longer exist.
 * Call after login or after any application/invite action completes.
 */
export function cleanupStaleNotifications() {
    const store = useMainStore();
    const notifications = store.notifications;
    const guild = store.guild;
    const invites = store.invites;

    const staleIds = [];

    notifications.forEach(notification => {
        if (notification.type === 'application-received') {
            // Guild leadership received an application — check if it still exists
            if (guild !== null && guild.applications) {
                const exists = guild.applications.find(a => a.user.username === notification.data.username);
                if (!exists) {
                    staleIds.push(notification.id);
                }
            }
        } else if (notification.type === 'invite-received') {
            // User received a guild invite — check if it still exists
            const exists = invites.find(i => i.guild.name === notification.data.name);
            if (!exists) {
                staleIds.push(notification.id);
            }
        }
    });

    // Fire delete requests for stale notifications
    staleIds.forEach(id => {
        store.deleteNotificationRequest(id)
            .catch(() => {});
    });

    return staleIds.length;
}
